import { AppRoutingConstants } from "../../app-routing.constants";
export class PropertiesRoutingConstants {
    static PROPERTIES_ROUTE = AppRoutingConstants.createRouteToView("properties");
}
